import {
  AccountBalanceIcon,
  AttachMoneyIcon,
  DescriptionIcon,
  FileCopyIcon,
  GroupsIcon,
  HomeWorkIcon,
  PeopleIcon,
  Person2Icon,
  ReceiptIcon,
  SupervisedUserCircleIcon,
} from "src/Pages/components/Icons/Icons";

export const normalizeCategory = (value: string) => {
  return value
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toUpperCase();
};

export const getLogEntityIcon = (normalizedType: string) => {
  if (
    ["USUARIOS", "PRODUTORES", "TIPO DE PRODUTOR", "LOGINS", "PERMISSOES"].includes(
      normalizedType,
    )
  ) {
    return <Person2Icon sx={{ fontSize: 18 }} />;
  }

  if (
    [
      "EMPRESA",
      "EMPRESAS",
      "FILIAIS",
      "ADMINISTRADORAS",
      "OPERADORAS",
      "PARCERIAS",
    ].includes(normalizedType)
  ) {
    return <HomeWorkIcon sx={{ fontSize: 18 }} />;
  }

  if (
    [
      "CONTRATOS",
      "PARCELAS",
      "CONTA CORRENTE",
      "ITENS EM ABERTO",
      "PARCELAS BORDERO",
      "PAGAMENTO",
    ].includes(normalizedType)
  ) {
    return <ReceiptIcon sx={{ fontSize: 18 }} />;
  }

  if (
    [
      "COMISSAO CORRETORA",
      "COMISSAO PRODUTOR",
      "COMISSOES ADMINISTRADORA",
      "GRUPOS DE IMPOSTO",
      "IMPOSTO GLOBAL",
      "ASSINATURA",
      "UPLOAD DE COMISSOES",
    ].includes(normalizedType)
  ) {
    return <AttachMoneyIcon sx={{ fontSize: 18 }} />;
  }

  if (
    [
      "AUTENTICACAO",
      "RECUPERACAO DE SENHA",
      "SISTEMA",
      "UTILITARIOS",
      "MODALIDADES",
      "METRICAS",
    ].includes(normalizedType)
  ) {
    return <AccountBalanceIcon sx={{ fontSize: 18 }} />;
  }

  if (["ARQUIVOS"].includes(normalizedType)) {
    return <FileCopyIcon sx={{ fontSize: 18 }} />;
  }

  if (
    [
      "LOGS",
      "LOGS DE EMAIL",
      "LOGS DE ERROS",
      "LOGS DO SISTEMA",
      "ERROS",
      "TEMPLATES DE EMAIL",
      "LAYOUT OPERADORAS",
    ].includes(normalizedType)
  ) {
    return <DescriptionIcon sx={{ fontSize: 18 }} />;
  }

  if (["GRUPOS"].includes(normalizedType)) {
    return <GroupsIcon sx={{ fontSize: 18 }} />;
  }

  if (["PESSOAS"].includes(normalizedType)) {
    return <PeopleIcon sx={{ fontSize: 18 }} />;
  }

  if (["PERFIL"].includes(normalizedType)) {
    return <SupervisedUserCircleIcon sx={{ fontSize: 18 }} />;
  }

  return null;
};
